import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Type from '../../model/newstype';
import TypeFormTemplate from './types.form.template';
import Types from '../../collection/refbooks/types';

import Config from '../../config';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/types.list',

    url() {
        return 'types';
    },

    open() {
        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: {

                disabled: () =>
                    !Config.privileges().includes( 'create_type' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: () =>
                    this.trigger( TypeFormTemplate.OPEN_TYPE, 
                        new Type(), 
                        this.state().cluster ),

            },
            
            edit: {

                disabled: () =>
                    !Config.privileges().includes( 'update_type' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: current => 
                    this.trigger( TypeFormTemplate.OPEN_TYPE, current.clone() ),
                    
            },
            
            destroy: {

                disabled: () => {
                    if (!Config.privileges().includes( 'delete_type' )) 
                        return true;

                    if (!['GLOBAL', 'CLUSTER'].includes( Config.level() ))
                        return true;

                    if (Config.level() === 'GLOBAL')
                        return false;

                    // Роль уровня кластера может редактировать/удалять только сущности своего кластера;
                    // в списке уже только "мои" сущности, но с примесью глобальных;
                    // поэтому достаточно только запретить редактировать глобальные
                    return !this.options.paged.current().get( 'cluster' );
                },

                handler: current =>
                    this.destroy( current, 
                        'type::modal delete - title', 
                        'type::modal delete - confirmation text' ),

            },
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )
        this.options.source = new Types( this.options.types.models );
        this.options.sorted = new Types();
        this.options.filtered = new Types();
        this.options.paged = new Types( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

    // need to override to pass typeGroups to grid
    serialize() {
        return {
            ...RefBooksList.prototype.serialize.call( this ),
            typeGroups: this.options.typeGroups
        }
    }

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.list.js